import { Injectable, OnDestroy } from '@angular/core';
import { Base } from './base';

@Injectable()
export abstract class BaseService extends Base implements OnDestroy {
    ngOnDestroy() {
        this.Destroy();
    }
}
